/**
 * Development environment configuration for the end-user chat widget.
 * Overridden by environment.prod.ts in production builds via angular.json fileReplacements.
 */
export const environment = {
  production: false,
  /** Base URL for the v2 public chat application (used for redirecting to the new UI). */
  publicChatBaseUrl: 'http://localhost:4204',
};
